<template>
    <div>
        <b-row>
            <b-col>
                <h4>Despesas</h4>
            </b-col>
            <b-col class="text-right">
                <b-button variant="secondary" size="sm" @click="voltar()"><i class="fas fa-arrow-left"></i> Voltar</b-button>
            </b-col>

        </b-row>
        <b-row align-v="end">
            <b-col>
                <label for="">De</label>
                <date-picker v-model="filtro.fromDate" :config="datePickerConfig" placeholder="Data de:"></date-picker>
            </b-col>
            <b-col>
                <label for="">Ate</label>
                <date-picker v-model="filtro.toDate" :config="datePickerConfig" placeholder="Data até:"></date-picker>
            </b-col>
            <b-col>
                <label for="">Despesa</label>
                <b-form-select v-model="filtro.despesa" :options="optionsDespesa"></b-form-select>
            </b-col>
            <b-col>
                <label for="">Usuário</label>
                <b-form-select v-model="filtro.usuario" :options="listUsuarios"></b-form-select>
            </b-col>
            <b-col>
                <label for="">Status</label>
                <b-form-select v-model="filtro.status" :options="listStatus"></b-form-select>
            </b-col>
            <b-col>
                <b-button title="Buscar" variant="primary" @click="loadDespesas"><i class="fa fa-search"></i></b-button>
                <b-button class="ml-2" title="Limpar Filtro" variant="secondary" @click="limpaFiltro()"><i class="fa fa-history"></i> </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col class="text-right">
                <h3 class="text-primary" v-if="totalDespesa > 0">Total em despesas: R$ {{
                    totalDespesa.toFixed(2) }}</h3>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-table :items="despesas" :fields="fields" :busy="loading" hover striped small stacked="md" show-empty empty-text="Nenhuma despesa encontrada ...">
                <template #cell(actions)="row">
                    <div class="custom-actions">
                        <div class="btn-group">
                            <b-button v-if="row.item.status === 'PENDENTE'" title="Aprovar Despesa"  variant="success" size="sm"  @click="aprova(row.item.id, row.item.valor)">
                                <i class="fa fa-thumbs-up"></i>
                            </b-button>
                            <b-button v-if="row.item.status === 'APROVADO'" title="Visualizar Despesa"  variant="secondary" size="sm" @click="visualizar(row.item.id)">
                                <i class="fas fa-eye"></i>
                            </b-button>
                            <b-button v-if="row.item.status === 'PENDENTE'" variant="primary" size="sm" title="Editar Despesa" @click="edit(row.item.id)">
                                <i class="fa fa-edit"></i>
                            </b-button>
                        </div>
                        <div class="modal fade" id="actionModal" tabindex="-1" role="dialog" aria-labelledby="actionModal">
                            <div class="modal-dialog modal-lg" role="document">
                            </div>
                        </div>
                    </div>
                </template>
                <template #cell(status)="row">
                    <b-badge v-if="row.item.status == 'APROVADO'" variant="success">Aprovada</b-badge>
                    <b-badge v-else variant="warning">Pendente</b-badge>
                </template>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando Despesas ...</strong>
                    </div>
                </template>
            </b-table>
        </b-row>
        <b-row>
            <b-pagination v-if="rows > 15" v-model="currentPage" :total-rows="rows" :per-page="perPage"
                @input="loadDespesas()"></b-pagination>
        </b-row>
        <b-modal size="lg" v-model="modalDespesas">
            <div class="container">
                <b-card>
                    <b-card-body>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label> Tipo de Despesa</label>
                                    <v-select :disabled="!editarDespesa" v-model="despesa.tipo" :options="listDespesa"></v-select>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>Valor R$</label>
                                    <input :disabled="!editarDespesa" v-model="despesa.valor" class="form-control" type="text"
                                        v-mask="['#.##', '##.##', '###.##']" />
                                </div>
                            </b-col>
                            <b-col>
                                <div class="form-group">
                                    <label>Data </label>
                                    <date-picker :disabled="!editarDespesa" v-model="despesa.data" :config="datePickerConfig"></date-picker>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <div class="form-group">
                                    <label>OBS</label> <small>Em caso de Outros, este campo é obrigatório.</small>
                                    <textarea :disabled="!editarDespesa" v-model="despesa.obs" class="form-control"></textarea>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col v-if="!despesa.nota && editarDespesa">
                                <div class="form-group">
                                    <label>Cupom Fiscal/Nota Fiscal </label>
                                    <input :disabled="!editarDespesa" type="file" class="form-control" accept="image/jpeg, image/png"
                                        @change="loadFile" />
                                </div>
                            </b-col>
                            <b-col v-else-if="despesa.nota">
                                <a :href="'/' + despesa.nota" target="_blank">
                                    <img class="img-thumbnail" v-bind:src="'/' + despesa.nota" width="300" />
                                </a>
                            </b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </div>
            <template #modal-header>
                <h4>{{ despesa.user }}</h4>
            </template>
            <template #modal-footer>
                <b-button v-if="editarDespesa" size="sm" variant="primary" @click="saveDespesa"><i class="fas fa-save"></i> Salvar</b-button>
                <b-button size="sm" variant="danger" @click="modalDespesas = false">{{ editarDespesa ? "Cancelar" : "Fechar" }}</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment';
import DatePicker from "vue-bootstrap-datetimepicker/src/component";

export default {
    components: { DatePicker },
    props: [],
    data() {
        return {
            despesa: {
                tipo:'',
                valor: '',
                data:'',
                obs:'',
                nota: null,
                user: null
            },
            listDespesa: [
                {
                    label: 'Alimentação',
                    value: 'ALIMENTACAO'
                }, {
                    label: 'Combustível',
                    value: 'COMBUSTIVEL'
                }, {
                    label: 'Hospedagem',
                    value: 'HOSPEDAGEM'
                }, {
                    label: 'Outros',
                    value: 'Outros'
                },
                {
                    label: 'Pedágio',
                    value: 'PEDAGIO'
                },
            ],
            modalDespesas: false,
            currentPage: 1,
            rows: 0,
            perPage: 20,
            filtro: {
                fromDate: moment().subtract(1,'months').format('DD/MM/YYYY'),
                toDate: moment().format('DD/MM/YYYY'),
                despesa: null,
                usuario: null,
                status: null
            },
            datePickerConfig: {
                'format': 'DD/MM/YYYY',
                'showClose': true
            },
            fields: [
                {
                    key: 'actions',
                    label: ''
                },
                {
                    key: 'id',
                    label: 'Código'
                },

                {
                    key: 'tipo',
                    label: 'Despesa'
                },
                {
                    key: 'status',
                    label: 'Status'
                },
                {
                    key: 'data',
                    label: 'Data',
                    formatter: (value) => {
                        return moment(value).format("DD/MM/YYYY")
                    },
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    formatter: (value) => {
                        return 'R$' + value.replace('.', ',')
                    },
                },
                {
                    key: 'usuario.name',
                    label: 'Usuario'
                },
            ],
            listStatus: [
                { value: null, text: 'Todos' },
                { value: 'PENDENTE', text: 'Pendente' },
                { value: 'APROVADO', text: 'Aprovada' },
            ],
            optionsDespesa: [
                { value: null, text: 'Todos' },
                { value: 'ALIMENTACAO', text: 'Alimentação' },
                { value: 'COMBUSTIVEL', text: 'Combustivel' },
                { value: 'HOSPEDAGEM', text: 'Hospedagem' },
                { value: 'PEDAGIO', text: 'Pedagio'},
                { value: 'Outros', text: 'Outros' },
            ],
            despesas: [],
            loading: false,
            totalDespesa: 0,
            listUsuarios: [],
            editarDespesa: false
        }
    },
    methods: {
        voltar() {
            window.location.href = "/adm/rotas";
        },
        limpaFiltro() {
            this.filtro = {
                fromDate: moment().subtract(1,'months').format('DD/MM/YYYY'),
                toDate: moment().format('DD/MM/YYYY'),
                despesa: null,
                usuario: null,
                status: null
            }
        },
        visualizar(id) {
            this.editarDespesa = false
            this.editar(id);
        },
        edit(id){
            this.editarDespesa = true;
            this.editar(id);
        },
        editar(id) {
            var vm = this;            
            $('.loading').show();
            axios.get('/adm/rotas/despesas/show', { params: { id: id } }).then(function (response) {
                console.log(response.data);
                let obj = response.data;
                vm.despesa.obs = obj.obs;
                vm.despesa.id = obj.id;
                vm.despesa.valor = parseFloat(obj.valor).toFixed(2);
                vm.despesa.tipo = obj.tipo;
                vm.despesa.data = moment(obj.data);
                vm.despesa.nota = obj.path_nota;
                vm.despesa.user = obj.usuario.name;
                $('.loading').hide();
                vm.modalDespesas = true;               
            }).catch(function (error) {
                $('.loading').hide();
                var erro = error.data.errors;
                console.log(error)
                vm.$swal('Ops', erro, 'error');
                console.log(error.data.errors);
            });
        },
        saveDespesa() {
            if (this.despesa.tipo === '') {
                return this.$swal('Ops', 'Informe Qual a sua despesa', 'warning');
            } else {
                if (this.despesa.tipo.value === 'OUTROS' && this.despesa.obs === '') {
                    return this.$swal('Ops', 'Quando a despesa for do tio Outros, informe os detalhes na observação.', 'warning');
                }
            }
            if (this.despesa.valor === '' || this.despesa.valor <= 0) {
                return this.$swal('Ops', 'Informe um Valor válido da sua despesa', 'warning');
            }
            if (this.despesa.data === '') {
                return this.$swal('Ops', 'Informe a Data', 'warning');
            }
            $('.loading').show();
            var data = {
                data: this.despesa.data.format('Y-M-D'),
                valor: this.despesa.valor,
                tipo: this.despesa.tipo,
                obs: this.despesa.obs,
                id: this.despesa.id,
                image: this.despesa.nota
            }
            var vm = this;
            axios.post('/adm/rotas/despesas/add', data).then(function (response) {
                console.log(response.data);
                let obj = response.data.success;                
                vm.$swal('Ok', obj, 'success');
                vm.modalDespesas = false;
                vm.loadDespesas();             
            }).catch(function (error) {
                $('.loading').hide();
                var erro = error.data.errors;
                vm.$swal('Ops', erro, 'error');
                console.log(error.data.errors);
            }).finally(() => {
                $('.loading').hide();
            });

        },       
        loadFile(e) {
            var vm = this;
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.onload = e => {
                vm.act_nota = e.target.result;
            };
            reader.readAsDataURL(image);
        },
        aprova(id, valor) {
            const vm = this;
            vm.$swal({
                title: 'Deseja aprovar esta Despesa ?',
                html: '<h3>Aprovando a despesa, a mesma ficará disponível para o pagamento.</h3>' +
                    '<input id="swalValor" step="any" class="swal2-input" value="' + valor + '" type="number">' +
                    '<input id="swalJust" class="swal2-input" placeholder="Justificativa">',
                focusConfirm: false,
                width: 600,
                padding: '3em',
                showCancelButton: true,
                confirmButtonText: 'Aprovar',
                cancelButtonText: 'Cancelar',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    var data = {
                        id: id,
                        valor: document.getElementById('swalValor').value,
                        justificativa: document.getElementById('swalJust').value
                    }
                    return axios.post('/adm/despesas/aprova', data).then(function (response) {
                        vm.loadDespesas();
                        return response.data;
                    }).catch(error => {
                        var erro = error.response.data;
                        vm.$swal.showValidationMessage(
                            erro ? erro : `erro desconhecido...: ${error}`
                        );
                        console.log(error);
                    })
                },
                allowOutsideClick: () => !vm.$swal.isLoading()
            }).then((result) => {
                if (result.value) {
                    vm.$swal('Ok', result.value, 'success');
                }
            })
        },
        loadDespesas() {
            const vm = this;
            vm.loading = true;
            let data = {
                currentPage: vm.currentPage,
                fromDate:vm.filtro.fromDate,
                toDate: vm.filtro.toDate,
                despesa: vm.filtro.despesa,
                usuario: vm.filtro.usuario,
                status: vm.filtro.status
            }
            axios.get('/adm/rotas/despesas/show', { params: data }).then((response) => {
                vm.despesas = response.data.data;
                vm.rows = response.data.total
                //console.log(response)
            }).catch((erro) => {
                console.log(erro);
            }).finally(() => {
                vm.loading = false;
            })
        },
        loadUsers() {
            const vm = this;
            axios.get('/user/perfil/gestor').then((response) => {
                vm.listUsuarios = [{ value: null, text: 'TODOS' }];
                response.data.map((el) => {
                    vm.listUsuarios.push({ value: el.id, text: el.name.toUpperCase() });
                })
            }).catch((erro) => {
                console.log(erro);
            })
        },
    },

    computed: {

    },
    mounted() {
        this.loadUsers();
        this.loadDespesas();
    },
    created() {

    }
}
</script>
<style></style>


// WEBPACK FOOTER //
// resources/assets/js/components/rotas/adm/List.vue